import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import styles from "./index.module.scss"
import Utils from '@utils/utils';
import API from '@api/api';
import { Button, message, Modal, Radio, Spin } from "antd";
import QRCode from 'qrcode.react'
import { InfoCircleOutlined } from '@ant-design/icons'
import { ActionSheet } from 'antd-mobile'
const token = "933d2480d2a64693ae6ed7d55a86fb65"
const Pricing = () => {
    const [open, setOpen] = useState(false)
    const [channelOpen, setChannelOpen] = useState(false)
    const [payItem, setPayItem] = useState()
    const onPay = useCallback((item, type) => {
        console.log('onPay', item, type)
        if (type == "mobile") {
            setChannelOpen(true)
            setPayItem(item)
        } else {
            setOpen(true)
            setPayItem(item)
        }
    }, [])

    // 移动端支付
    const isMounted = useRef(true)
    const tradeIdRef = useRef()
    const [messageApi, contextHolder] = message.useMessage();
    useEffect(() => {
        return () => isMounted.current = false
    }, [])
    const checkStatusFunc = useCallback(() => {
        return new Promise((resolev, reject) => {
            const currentTradeId = tradeIdRef.current
            const loopCheck = () => {
                if (currentTradeId != tradeIdRef.current) return reject('cancel')
                API.getOrderStatus({
                    tradeId: currentTradeId,
                    token,
                }).then(res => {
                    if (res.code != 0) return resolev({
                        status: false,
                        message: res.message
                    })
                    const trade = res.data
                    if (trade.status == 'success') {
                        tradeIdRef.current = null
                        return resolev({
                            status: true,
                        })
                    } else if (trade.status == 'closed') {
                        tradeIdRef.current = null
                        return resolev({
                            status: false,
                            message: '订单关闭，请重新购买'
                        })
                    } else {
                        if (isMounted.current) setTimeout(loopCheck, 1000)
                        else reject('cancel')
                    }
                }).catch(err => {
                    if (err.code == "ERR_NETWORK") {
                        if (isMounted.current) setTimeout(loopCheck, 1000)
                        else reject('cancel')
                    } else {
                        reject(err)
                    }
                })
            }
            loopCheck()
        })
    }, [])
    const handleMobilePay = useCallback((payItem, channel) => {
        return API.payForOrder({
            amount: payItem.price,
            channel: channel, // wechat_wap / alipay_wap
            subject: payItem.title,
            token: token
        }).then(res => {
            if (res?.code != 0) throw new Error(res.message)
            if (channel == "wechat_wap") {
                window.location.href = res.data.payUrl
                // window.open(res.data.payUrl, '_blank')
            } else {
                let divForm = document.getElementsByTagName('__pay_form')
                if (divForm.length) document.body.removeChild(divForm[0])
                const div = document.createElement('__pay_form');
                div.innerHTML = res.data.payUrl;
                document.body.appendChild(div);
                document.forms[0].setAttribute('target', '_self')
                document.forms[0].submit();
            }
            const tradeId = res.data.tradeId
            tradeIdRef.current = res.data.tradeId
            // 查询订单状态
            checkStatusFunc().then(payStatus => {
                if (payStatus.status) {
                    messageApi.open({
                        key: tradeId,
                        type: 'success',
                        content: '支付成功',
                        duration: 2,
                    })
                } else {
                    messageApi.open({
                        key: tradeId,
                        type: 'warning',
                        content: payStatus.message,
                        duration: 2,
                    }) 
                }
            }).catch(err => {
                console.log(err)
                if (err == 'cancel') return
                messageApi.open({
                    key: tradeId,
                    type: 'error',
                    content: err.message,
                    duration: 2,
                })
            })
        }).catch(err => {
            console.log('err', err)
            message.error(err.message)
        })
    }, [checkStatusFunc])
    const actions = useMemo(() => [
        {
            text: <div className={styles.ActionSheetAction}><img src={require('@assets/images/icon_alipay.png')} />支付宝</div>,
            key: 'alipay_wap',
            onClick: () => {
                handleMobilePay(payItem, "alipay_wap")
            }
        }, {
            text: <div className={styles.ActionSheetAction}><img src={require('@assets/images/icon_wxpay.png')} />微信</div>,
            key: 'wechat_wap',
            onClick: () => {
                handleMobilePay(payItem, "wechat_wap")
            }
        }
    ], [handleMobilePay, payItem])

    return (
        <>
        {contextHolder}
        {
            Utils.isMobileDevice() ?
            <PricingMobile onPay={onPay} /> :
            <PricingDesktop onPay={onPay} />
        }
        <Modal
            open={open}
            onCancel={() => setOpen(false)}
            destroyOnHidden
            footer={null}
        >
            <PayModal payItem={payItem} onClose={() => setOpen(false)} />
        </Modal>
        <ActionSheet
            extra='请选择支付方式'
            cancelText='取消'
            visible={channelOpen}
            actions={actions}
            onClose={() => setChannelOpen(false)}
        />
        </>
    )
}

export default Pricing

function PayModal (props) {
    const { payItem, onClose } = props
    const isMounted = useRef(true)
    // "amount":"20",
    // "channel":"alipay_web",/支付渠道 wechat_web/wechat_wap/alipay_web/alipay_wap
    // "subject":"PSAI交付服务"
    const [channel, setChannel] = useState("alipay_web")
    const [payUrl, setPayUrl] = useState()
    const tradeIdRef = useRef()

    useEffect(() => {
        return () => isMounted.current = false
    }, [])

    useEffect(() => {
        API.payForOrder({
            amount: payItem.price,
            channel: channel, // 
            subject: payItem.title,
            token: token
        }).then(res => {
            console.log('res', res)
            if (res?.code != 0) throw new Error(res.message)
            setPayUrl(res.data?.payUrl)
            tradeIdRef.current = res.data?.tradeId
        }).catch(err => {
            console.log('err', err)
            message.error(err.message)
        })
    }, [channel, payItem])

    const checkTradeStatus = useCallback(() => {
        if (!isMounted.current) return
        if (!tradeIdRef.current) {
            setTimeout(() => {
                if (isMounted.current) checkTradeStatus()
            }, 1000)
            return
        }
        API.getOrderStatus({
            tradeId: tradeIdRef.current,
            token,
        }).then(res => {
            if (res.code != 0) return
            const item = res.data
            if (item.status == 'success') {
                console.log('订单支付成功', item.tradeId)
                message.success('支付成功')
                onClose()
                return
            } else if (item.status == 'closed') {
                console.log('订单关闭，刷新订单', item.tradeId)
                message.success('订单已关闭')
                onClose()
                return
            } else {
                setTimeout(() => {
                    console.log(isMounted.current)
                    if (isMounted.current) checkTradeStatus()
                }, 1000)
            }
        })
    }, [])
    
    useEffect(() => {
        checkTradeStatus()
    }, [])

    return (
        <div className={styles.PayModal}>
            <div>PSAI Master {payItem.title}</div>
            <div>扫码支付 <span>{payItem.price}</span> 元</div>
            <div className={styles.Qrcode}>
            {
                payUrl && channel == 'alipay_web' ?
                    <AlipayQrcode key={payUrl} url={payUrl} /> :
                payUrl && channel == 'wechat_web' ?
                    <WechatQrcode key={payUrl} url={payUrl} /> :
                null
            }
            </div>
            <div className={styles.ChannelBtn}>
                <div
                    className={channel == 'alipay_web' ? styles.Active : ''}
                    onClick={() => { setPayUrl(); setChannel('alipay_web') }}>
                    <img src={require('@assets/images/icon_alipay.png')} />支付宝</div>
                <div
                    className={channel == 'wechat_web' ? styles.Active : ''}
                    onClick={() => { setPayUrl(); setChannel('wechat_web') }}>
                    <img src={require('@assets/images/icon_wxpay.png')} />微信</div>
            </div>
            <div className={styles.tipsContent}>
                <span>支付完成后，默认为您同意<a target='_blank' href={`/master会员条款.htm?t=${new Date().getTime()}`}>相关协议条例</a></span>
                <span>虚拟商品，支付后无法退款</span>
            </div>
        </div>
    )
}

function PricingMobile (props) {
    const [packageList] = useState([{
        title: "POC图片套餐",
        price: 20,
        unit: "元/次",
        description: "最多4张成片交付权益",
    }, {
        title: "POC视频套餐",
        price: 30,
        unit: "元/部",
        description: "常规主图展示视频（不超过15秒）",
    }])

    return (
        <div className={styles.MobileContainer}>
            <div className={styles.Logo}></div>
            <div className={styles.Title}>PSAI交付服务</div>
            <div className={styles.Description}>出片快 · 高转化 · 超省心</div>
            <div className={styles.PackageList}>
            {packageList.map((item, index) => (
                <div key={index} className={styles.PackageItem}>
                    <div className={styles.PackageTitle}>{item.title}</div>
                    <div className={styles.PackagePrice}>
                        <span>{item.price}</span>
                        <span>{item.unit}</span>
                    </div>
                    <div className={styles.Divider}></div>
                    <div className={styles.PackageDescription}>{item.description}</div>
                    <div className={styles.PackageButton} onClick={() => props.onPay(item, "mobile")}>立即购买</div>
                </div>
                ))}
            </div>
        </div>
    )
}

function PricingDesktop (props) {
    const [packageList] = useState([{
        title: "POC图片套餐",
        price: 20,
        unit: "元/次",
        description: "最多4张成片交付权益",
    }, {
        title: "POC视频套餐",
        price: 30,
        unit: "元/部",
        description: "常规主图展示视频（不超过15秒）",
    }])
    
    return (
        <div className={styles.DesktopContainer}>
            <div className={styles.PackageWrap}>
                <div className={styles.Title}>PSAI交付服务</div>
                <div className={styles.Description}>出片快 · 高转化 · 超省心</div>
                <div className={styles.PackageList}>
                {packageList.map((item, index) => (
                    <div key={index} className={styles.PackageItem}>
                        <div className={styles.PackageTitle}>{item.title}</div>
                        <div className={styles.PackagePrice}>
                            <span>{item.price}</span>
                            <span>{item.unit}</span>
                        </div>
                        <div className={styles.Divider}></div>
                        <div className={styles.PackageDescription}>{item.description}</div>
                        <div ></div>
                        <div className={styles.PackageButton} onClick={() => props.onPay(item, "desktop")}>立即购买</div>
                    </div>
                ))}
                </div>
            </div>
            <div className={styles.Logo}></div>
        </div>
    )
}

const AlipayQrcode = (props) => {
    const alipayFrameRef = useRef()

    useEffect(() => {
        alipayFrameRef.current.contentWindow.document.write(props.url)
    }, [props.url])

    return (
        <div className={styles.PayContent} key={props.url}>
            <div className={styles.iframePlaceholderWrap}>
                <Spin wrapperClassName={styles.iframePlaceholderSpin} spinning>
                    <div className={`${styles.iframePlaceholder} ${styles.alipay}`}></div>
                </Spin>
            </div>
            <iframe ref={alipayFrameRef}
                className={styles.payFrame}
                style={{ display: 'block' }}
                // srcDoc={payUrl}
                width="200"
                height="200"
                marginWidth={0}
                marginHeight={0}
                frameBorder="0"
                border="0"
                scrolling="no"
            ></iframe>
        </div>
    )
}

const WechatQrcode = (props) => {
    // weixin://wxpay/bizpayurl?pr=aYnckdQz3
    return (
        <div className={styles.PayContent} key={props.url}>
            <QRCode
                id="qrcode"
                value={props.url}
                size={200}
                level="H"
                style={{ margin: 'auto' }}
                imageSettings={{
                    src: require('@assets/images/icon_wxpay@2x.png'),
                    width: 50,
                    height: 50,
                    excavate: true,
                }}
            />
        </div>
    )
}